import { Chip, ChipOwnProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import RefundStatusEnum from '../../enums/refundStatusEnum';

interface TransactionStatusChipProps {
	status: RefundStatusEnum; // A general status
}

const RefundStatusChip = ({ status }: TransactionStatusChipProps) => {
	const { t } = useTranslation();

	const getStatusLabel = (): string => {
		let result: string;

		switch (status) {
			case RefundStatusEnum.PartiallyRefuned:
			case RefundStatusEnum.Refunded:
				result = t('ui.status.refunded');
				break;
			case RefundStatusEnum.Pending:
				result = `${t('ui.refund')} ${t('ui.status.pending').toLowerCase()}`;
				break;
			default:
				result = t('unknown');
				console.warn('Unknown booking status');
				break;
		}

		return result;
	};

	const getStatusColor = (): ChipOwnProps['color'] => {
		let color: ChipOwnProps['color'];
		switch (status) {
			case RefundStatusEnum.PartiallyRefuned:
			case RefundStatusEnum.Pending:
				color = 'warning';
				break;
			case RefundStatusEnum.Failed:
				color = 'error';
				break;
			default:
				color = 'info';
				break;
		}

		return color;
	};

	return <Chip size='small' label={getStatusLabel()} color={getStatusColor()} />;
};

export default RefundStatusChip;
